import type { ISerialize } from '@/objects/ISerialize';
import { ProductionDisplayDataItem } from './ProductionDisplayDataItem';

export class ProductionDisplayData implements ISerialize {
    public FromItem: number;

    public Items: ProductionDisplayDataItem[];

    public Subtitle: string;

    public Title: string;

    public ToItem: number;

    public TotalItems: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        FromItem?: number;
        Items?: ProductionDisplayDataItem[];
        Subtitle?: string | null;
        Title?: string | null;
        ToItem?: number;
        TotalItems?: number;
    }) {
        this.FromItem = values.FromItem ?? 0;

        this.Items = values.Items ?? [];

        this.Subtitle = values.Subtitle ?? '';

        this.Title = values.Title ?? '';

        this.ToItem = values.ToItem ?? 0;

        this.TotalItems = values.TotalItems ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"FromItem": ${JSON.stringify(this.FromItem)}` +
            ',' +
            `"Items": [ ${this.Items.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Subtitle": ${JSON.stringify(this.Subtitle)}` +
            ',' +
            `"Title": ${JSON.stringify(this.Title)}` +
            ',' +
            `"ToItem": ${JSON.stringify(this.ToItem)}` +
            ',' +
            `"TotalItems": ${JSON.stringify(this.TotalItems)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionDisplayData from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        FromItem?: number;
        Items?: ProductionDisplayDataItem[];
        Subtitle?: string | null;
        Title?: string | null;
        ToItem?: number;
        TotalItems?: number;
    }): ProductionDisplayData {
        return new ProductionDisplayData(values);
    }

    public static _FromServerJson(json: any): ProductionDisplayData {
        return new ProductionDisplayData({
            FromItem: json.FromItem,
            Items: json.Items?.map((x: any) => ProductionDisplayDataItem._FromServerJson(x)),
            Subtitle: json.Subtitle ?? '',
            Title: json.Title ?? '',
            ToItem: json.ToItem,
            TotalItems: json.TotalItems,
        });
    }

    /**
     * Creates an instance of ProductionDisplayData from another instance of ProductionDisplayData.
     * @param other The ProductionDisplayData you want to clone
     * @returns A cloned ProductionDisplayData
     */
    public static FromOther(other: ProductionDisplayData): ProductionDisplayData {
        return ProductionDisplayData._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionDisplayData.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionDisplayData';
}
